import { render, staticRenderFns } from "./UserMinusIcon.vue?vue&type=template&id=7e11b95a&"
import script from "./UserMinusIcon.vue?vue&type=script&lang=js&"
export * from "./UserMinusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports